import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { Button } from 'flowbite-react';
import { canView, UserRole } from '../../utils/RoleManager';
import { HiMenu, HiOutlineHome } from 'react-icons/hi';

const Navigation: React.FC = () => {
  const { user, signOut } = useAuthContext();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
        if (window.innerWidth >= 768) {
        setMobileOpen(false); // auto-close mobile menu on desktop
        }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Define allowed roles at runtime (since TypeScript types don't exist at runtime)
    const validRoles: UserRole[] = ['master', 'clubAdmin', 'coach', 'parent'];

  const getRole = (rawRole: string | undefined): UserRole => {
  if (validRoles.includes(rawRole as UserRole)) {
    return rawRole as UserRole;
  }
  return 'coach'; // fallback role
};

const role: UserRole = getRole(user?.role);

const MenuLink = ({
  to,
  label,
  icon,
  onClick,
}: {
  to: string;
  label?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}) => (
  <Link to={to} className="w-full md:w-auto" onClick={onClick}>
    <Button
      pill
      className="w-full md:w-auto text-sm bg-darkblue text-white hover:bg-lightblue px-3 py-2 transition flex items-center gap-2 justify-start md:justify-center"
    >
      {icon && <span>{icon}</span>}
      {label && <span>{label}</span>}
    </Button>
  </Link>
);

  return (
    <>
      {/* Desktop Menu */}
      <nav className="hidden md:flex justify-center py-4">
        <div className="bg-white px-4 py-3 rounded-full shadow-md inline-flex flex-wrap justify-center gap-2">
          <MenuLink to="/dashboard" icon={HiOutlineHome({ className: 'h-5 w-5' })} label="Dashboard"/>
          {canView.players(role) && <MenuLink to="/players" label="Players" />}
          {canView.schedule(role) && <MenuLink to="/schedule" label="Schedule" />}
          {canView.messages(role) && <MenuLink to="/messages" label="Messages" />}
          {canView.payments(role) && <MenuLink to="/payments" label="Payments" />}
          {canView.teamManagement(role) && <MenuLink to="/team-management" label="Team Management" />}
          {canView.userManagement(role) && <MenuLink to="/user-management" label="User Management" />}
          {canView.settings(role) && <MenuLink to="/settings" label="Settings" />}
        </div>
      </nav>

      {/* Mobile Hamburger */}
      <div className="md:hidden flex justify-end p-4">
        <Button pill onClick={() => setMobileOpen(true)}>
            <span>{HiMenu({ className: 'h-5 w-5' })}</span>
        </Button>
      </div>
      
      {/* Mobile Drawer */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40" onClick={() => setMobileOpen(false)}>
            <div
            className="absolute top-16 right-4 bg-white shadow-lg rounded-lg p-4 z-50s flex flex-col gap-3"
            onClick={(e) => e.stopPropagation()} // prevent closing on click inside
            >
            <h2 className="text-xl font-semibold text-darkblue mb-2">Menu</h2>
            <MenuLink to="/dashboard" label="Dashboard" 
  onClick={() => setMobileOpen(false)}/>
            {canView.players(role) && <MenuLink to="/players" label="Players" 
  onClick={() => setMobileOpen(false)}/>}
            {canView.schedule(role) && <MenuLink to="/schedule" label="Schedule" 
  onClick={() => setMobileOpen(false)}/>}
            {canView.messages(role) && <MenuLink to="/messages" label="Messages" 
  onClick={() => setMobileOpen(false)}/>}
            {canView.payments(role) && <MenuLink to="/payments" label="Payments" 
  onClick={() => setMobileOpen(false)}/>}
            {canView.teamManagement(role) && <MenuLink to="/team-management" label="Team Management" 
  onClick={() => setMobileOpen(false)}/>}
            {canView.userManagement(role) && <MenuLink to="/user-management" label="User Management" 
  onClick={() => setMobileOpen(false)}/>}
            {canView.settings(role) && <MenuLink to="/settings" label="Settings" />}
            </div>
        </div>
        )}
    </>
  );
};

export default Navigation;